import {
    IMessageCacheFirstPayload,
    IMessageHeaderAppendResponderPayload,
    IMessageOAuthTokenPayload,
    IMessagePreCachePayload,
    IMessageZipRelativePathResponderPayload,
    MESSAGE_CACHEFIRST_TYPE,
    MESSAGE_CACHEOAUTH_TYPE,
    MESSAGE_HEADERAPPEND_TYPE,
    MESSAGE_PRECACHE_TYPE,
    MESSAGE_ZIPRELATIVEPATH_TYPE,
} from '../common/bridge.interface';
import { default as regexParser } from '../common/regex';

function _dispatchWorkerMessage(worker: ServiceWorker, message: any) {
    worker.postMessage(message);
}

function _messageRoutePreCacheFiles(paths: string[]): IMessagePreCachePayload {
    return {
        type: MESSAGE_PRECACHE_TYPE,
        payload: {
            paths,
        },
    };
}

function _messageRouteCacheFirst(
    matcher: RegExp,
    maxAge: number,
    maxEntries: number,
    cacheName: string,
    ignoreSearch?: boolean,
): IMessageCacheFirstPayload {
    return {
        type: MESSAGE_CACHEFIRST_TYPE,
        payload: {
            matcher: regexParser.stringify(matcher) /*  Regex not serializable by JSON.stringify */,
            maxAge,
            maxEntries,
            cacheName,
            ignoreSearch,
        },
    };
}

function _messageRouteCacheOAuthToken(pathSuffix: string): IMessageOAuthTokenPayload {
    return {
        type: MESSAGE_CACHEOAUTH_TYPE,
        payload: {
            pathSuffix,
        },
    };
}

function _messageRouteZipPathFetchResponder(
    zipPath: string,
    relativeRespondPath: string,
): IMessageZipRelativePathResponderPayload {
    return {
        type: MESSAGE_ZIPRELATIVEPATH_TYPE,
        payload: {
            zipPath,
            relativeRespondPath,
        },
    };
}

function _messageRouteHeaderAppend(
    matcher: RegExp,
    headerKey: string,
    headerVal: string,
    expiration: Date,
): IMessageHeaderAppendResponderPayload {
    return {
        type: MESSAGE_HEADERAPPEND_TYPE,
        payload: {
            matcher: regexParser.stringify(matcher),
            key: headerKey,
            val: headerVal,
            expiration: expiration.getTime(),
        },
    };
}

function addCacheFirst(
    worker: ServiceWorker,
    matcher: RegExp,
    maxAge: number,
    maxEntries: number,
    cacheName: string,
    ignoreSearch?: boolean,
) {
    _dispatchWorkerMessage(
        worker,
        _messageRouteCacheFirst(matcher, maxAge, maxEntries, cacheName, ignoreSearch),
    );
}

function addPreCache(worker: ServiceWorker, paths: string[]) {
    _dispatchWorkerMessage(worker, _messageRoutePreCacheFiles(paths));
}

function addOAuthTokenCache(worker: ServiceWorker, pathSuffix: string) {
    _dispatchWorkerMessage(worker, _messageRouteCacheOAuthToken(pathSuffix));
}

function addZipPathFetchResponder(
    worker: ServiceWorker,
    zipPath: string,
    relativeRespondPath: string,
) {
    _dispatchWorkerMessage(
        worker,
        _messageRouteZipPathFetchResponder(zipPath, relativeRespondPath),
    );
}

function addHeader(
    worker: ServiceWorker,
    matcher: RegExp,
    headerKey: string,
    headerVal: string,
    expiration: Date,
) {
    _dispatchWorkerMessage(
        worker,
        _messageRouteHeaderAppend(matcher, headerKey, headerVal, expiration),
    );
}

export default {
    addCacheFirst,
    addPreCache,
    addOAuthTokenCache,
    addZipPathFetchResponder,
    addHeader,
};
